import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
/* Apollo */
import { ApolloProvider } from "@apollo/client";
import { Backdrop, CircularProgress } from "@mui/material";
/* Main App */
import App from "./App";
import store from "./store/index.js";
import theme from "./libs/theme";
import client from "./graphQL/index";
import { AUTH_USER_TOKEN_KEY, AUTH_ACCESS_TOKEN_KEY, AUTH_REFRESH_TOKEN_KEY } from "./utils/constants";

import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";

const handleAuthRedirect = () => {
  if (typeof window === "undefined") return;

  const hashParams = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
  const queryParams = new URLSearchParams(window.location.search || "");
  const idToken = hashParams.get("id_token") || queryParams.get("id_token");
  const accessToken = hashParams.get("access_token") || queryParams.get("access_token");
  if (!idToken && !accessToken) return;

  window.localStorage.setItem(AUTH_USER_TOKEN_KEY, idToken || accessToken);
  if (accessToken) {
    window.localStorage.setItem(AUTH_ACCESS_TOKEN_KEY, accessToken);
  }
  const refreshToken = hashParams.get("refresh_token") || queryParams.get("refresh_token");
  if (refreshToken) {
    window.localStorage.setItem(AUTH_REFRESH_TOKEN_KEY, refreshToken);
  }
  const provider = hashParams.get("provider") || queryParams.get("provider");
  if (provider) {
    window.localStorage.setItem("oauth_provider", provider);
  }
  window.localStorage.setItem("LOGIN_ACTION", "1");

  // Remove sensitive tokens from URL
  const nextParams = new URLSearchParams(window.location.search || "");
  ["id_token", "access_token", "refresh_token", "token_type", "expires_in", "state"].forEach((key) =>
    nextParams.delete(key)
  );
  const queryString = nextParams.toString();

  window.history.replaceState(
    {},
    document.title,
    window.location.pathname + (queryString ? "?" + queryString : "")
  );
};

handleAuthRedirect();

// root
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline></CssBaseline>
        <BrowserRouter>
          <Suspense
            fallback={
              <Backdrop open={true}>
                <CircularProgress color="inherit" size={60} />
              </Backdrop>
            }
          >
            <App />
          </Suspense>
        </BrowserRouter>
      </ThemeProvider>
      <ToastContainer></ToastContainer>
    </ApolloProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
